export default __webpack_public_path__ + "static/customer-insights.url-bde554ccd14a935d62e16edb0f06db2f.svg";